import * as _ from 'lodash';
import { useEffect, useState, Fragment, forwardRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import {
    Button, FormControl, FormGroup, TextField, Select, MenuItem, InputLabel, Box, NativeSelect, IconButton, Dialog, FormHelperText, OutlinedInput, Slider,
    DialogContent, DialogTitle, DialogContentText, DialogActions, Card, CardContent, Typography, CardActions, Breadcrumbs, Link, Checkbox, FormControlLabel, Grid,
    List, ListItem, Menu
} from "@mui/material";
import Slide from '@mui/material/Slide';
import { getThemeProps } from '@mui/system';
import theme from "../../../theme";
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';


import { FormContainer, TextFieldElement } from 'react-hook-form-mui'

import { dateFormatter } from "../../../lib/dates";
import { selectMisContratoById, useGetMisContratosQuery, useClasesContratosQuery } from "../../../redux/reducers/misContratosSlice";
import { selectAllCac } from "../../../redux/reducers/cacSlice";
import { useCrearLinkMecadoPagoMutation } from "../../../redux/reducers/adelantarPagoSlice";
import { useGetIndicesQuery } from "../../../redux/reducers/indicesSlice";
import { gridNumberComparator } from '@mui/x-data-grid';
import { getBonificaciones, getConversionesCAC } from '../../../edilia/index'
// Prueba animacion
import { motion } from "framer-motion"
const moneyFormat = v => '$' + new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((parseFloat((v))).toFixed(2)).replace("ARS", "")
const zfill = (number, width) => {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */
    var zero = "0"; /* String de cero */

    if (width <= length) {
        if (number < 0) {
            return ("-" + numberOutput.toString());
        } else {
            return numberOutput.toString();
        }
    } else {
        if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
        }
    }
}
function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
};
function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(",");
    date = date[0].split("/");

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];
    return d + '/' + m + '/' + y
};
const fechaSortComparator = (v1, v2, param1, param2) => {
    function getFechaNumero(date) {
        date = date.split('/')
        let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
        let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
        let y = date[2];
        var fullDate = y + m + d;
        return parseInt(fullDate);
    }
    let fecha1 = getFechaNumero(param1.value)
    let fecha2 = getFechaNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
        fecha1,
        fecha2,
    );
    if (ComparatorResult !== 0) {
        return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const importeSortComparator = (v1, v2, param1, param2) => {
    function getImporteNumero(importe) {
        importe = importe.replace('$', '').replace(',', '').replace('.', '')
        return parseInt(importe);
    }
    let number1 = getImporteNumero(param1.value)
    let number2 = getImporteNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
        number1,
        number2,
    );
    if (ComparatorResult !== 0) {
        return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
};

const MisContratosCat = () => {
    const currentUser = useSelector(selectCurrentUser);
    const pathname = useLocation().pathname.toLowerCase();
    const navigate = useNavigate();
    const [contratoId, setContratoId] = useState(null);
    const [showModalCambios, setShowModalCambios] = useState(Date.now() < 1706756400000); // Lo muestro si es antes del 1 de febrero 2024
    const { data: misContratos, isLoading, isSuccess, isError, error } = useGetMisContratosQuery();
    const { data: indices } = useGetIndicesQuery();

    const [crearLink] = useCrearLinkMecadoPagoMutation();

    useEffect(() => setContratoId(pathname.split('miscontratos/')[1]), [navigate]);
    const getIndiceAt = (fecha = new Date()) => {
        if (indices?.entities == null) return 1;
        fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
        return Object.values(indices.entities)
            .filter(i => {
                const iFecha = new Date(parseInt(i.fecha));
                return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
            }).
            sort((a, b) => a.fecha - b.fecha)
        [0];
    };

    // Lista de Cards de mis contratos
    const MisContratos = (props) => {
        const ContratoCard = (props) => {
            let ultimaHistoria = _.last(props?.historia);
            let descripcion = ultimaHistoria?.claseContratoActual?.descripcion;
            let estado = ultimaHistoria?.estado;
            
            const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
                + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
                + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
                + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
                + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
                + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
            let GA = getConversionesCAC(valorContratoCAC, { ...estado?.indice, cac: parseInt(estado?.indice?.cac) }, ultimaHistoria?.claseContratoActual)?.ga
            return (
                <Fragment>
                    <Card sx={{ minWidth: 275, margin: '10px' }}>
                        <CardContent>
                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                Clase: {`${props.contrato.claseContratoId} `}  Serie: {`${props.contrato.serie} `}  ContratoID: {`${zfill(props.contrato.contratoId)} `}
                            </Typography>
                            {props.contrato?.fechaPerfeccionamiento === null ?
                                <>
                                    <Typography sx={{ margin: "10px" }}>Su contrato está en proceso de ser aprobado por la compañía fiduciaria.</Typography>
                                    <Typography sx={{ margin: "10px" }}>Una vez validado, verá toda su información aquí.</Typography>
                                </>
                                : <>
                                    <Typography variant="h6" fontWeight='bold' color='primary' component="div">
                                        {descripcion}
                                    </Typography>
                                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                        Grado de Avance {(GA * 100).toFixed(2)}%
                                    </Typography>
                                </>}
                        </CardContent>
                        {props.contrato?.fechaPerfeccionamiento === null ? null :
                            <CardActions>
                                <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ fontWeight: "bold", marginLeft: "0.5em" }} size="small" onClick={() => navigate(`/dashboard/miscontratos/${props.contrato.contratoId}`)}>Detalles</Button>
                            </CardActions>
                        }
                    </Card>
                </Fragment>
            )
        };
        const handleClickOpen = () => setShowModalCambios(true);

        const handleClose = () => setShowModalCambios(false);
        const ModalCambios = () => {
            const dropIn = {
                hidden: {
                    y: "-100vh",
                    opacity: 0
                },
                visible: {
                    y: 0,
                    opacity: 1,
                    transition: {
                        duration: 0.1,
                        type: "spring",
                        damping: 25,
                        stiffness: 500,
                    }
                },
                exit: {
                    y: "100vh",
                    opacity: 0
                }
            };
            return (
                <>
                    <Dialog
                        // ref={scope}
                        key={'animationModal'}
                        open={showModalCambios}
                        TransitionComponent={Slide}
                        //TransitionProps={{direction: "up"}}
                        keepMounted
                        onClose={handleClose}
                        aria-describedby="alert-dialog-slide-description"
                   // component={motion.div}
                    //  variants={dropIn}
                    //  initial="hidden"
                    //  animate="visible"
                    //  exit="exit"
                    // initial={{ scale: 0 }}
                    // animate={{ rotate: 360, scale: 1 }}
                    // exit={{ scale: 0 }}
                    // transition={{
                    //     type: "spring",
                    //     stiffness: 90,
                    //     damping: 20,
                    //     // repeat: Infinity
                    // }}
                    //drag
                    // drag="y"
                    //drag="x"
                    // dragTransition={{
                    //     min: 0,
                    //     max: 100,
                    //     bounceStiffness: 100
                    // }}
                    //dragConstraitns={{ left: 50 }}
                    >
                        <DialogTitle>{"Novedades en la visualización de tus contratos"}</DialogTitle>
                        <DialogContent dividers>
                            <DialogContentText
                                id="alert-dialog-slide-description">
                                Ahora vas a poder ver las bonificaciones por adelantos asociadas a cada uno de tus pagos que se calculan automáticamente para determinar el grado de avance de tu contrato (Las mismas siempre fueron consideradas, ahora además son visibles).
                                
                            </DialogContentText>
                            <DialogContentText> Saludos,</DialogContentText>
                            <DialogContentText>El Equipo de Edilia</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }}
                                onClick={handleClose}>Aceptar</Button>
                        </DialogActions>
                    </Dialog>
                </>);
        }

        return (
            <div>
                
                <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}> Mis Contratos:</Typography>
                {Object.values(misContratos?.entities || {})?.map(c => <ContratoCard {...c} key={'cantratoCardMiscontratos' + c.contrato.contratoId}></ContratoCard>)}
            </div>
        )
    }
    // Detalle de un contrato en particular
    const Contrato = (prop) => {

        let CACs = useSelector((state) => selectAllCac(state));
        let contrato = useSelector((state) => selectMisContratoById(state, contratoId));
        const [adelantarPago, setAdelantarPago] = useState(false);
        const [showSuscripcion, setShowSuscripcion] = useState(false);
        const [detallePago, setDetallePago] = useState(null);
        let now = new Date();
        const indiceActual = now.getMonth() >= 3 ?
            getIndiceAt(now.setMonth(now.getMonth() - 3)) :
            getIndiceAt(now.setMonth(now.getMonth() + 9) && now.setFullYear(now.getFullYear() - 1));
        const adelantoRecurrenteNominal = ((contrato?.contrato?.adelantoRecurrenteCAC) * (indiceActual?.cac)).toFixed(2)

        const ContratoInformacionResumida = (contrato) => {

            let ultimaHistoria = _.last(contrato?.historia);
            let descripcion = ultimaHistoria?.claseContratoActual?.descripcion;
            let estado = ultimaHistoria?.estado;
            const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
                + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
                + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
                + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
                + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
                + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
            let valor = getConversionesCAC(valorContratoCAC, { ...ultimaHistoria?.estado?.indice, cac: parseInt(ultimaHistoria?.estado?.indice?.cac) }, { ...ultimaHistoria?.claseContratoActual })

            let GA = valor?.ga
            let cuo = valor?.cuotasEq
            return (
                <Card sx={{ minWidth: 275, margin: '10px' }}>
                    <CardContent>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            {`Serie: ${contrato?.contrato?.serie}    Clase: ${contrato?.contrato?.claseContratoId}     ContratoID: ${contrato?.contrato?.contratoId}`}
                        </Typography>
                        <Typography variant="h6" color={"primary"} fontWeight={'bold'} component="div">
                            {descripcion}
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography sx={{ marginTop: '.6em' }} color="text.secondary">
                                    {`Grado de Avance: ${(GA * 100 || 0).toFixed(2)}%`}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={4}>
                                <Typography sx={{ marginTop: '.6em' }} color="text.secondary">
                                    {`M2 Eq: ${(contrato?.estado?.m2Equivalentes || 0).toFixed(2)}m2`}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={4}>
                                <Typography sx={{ marginTop: '.6em' }} color="text.secondary">
                                    {`Cuotas Eq: ${(cuo || 0).toFixed(2)}`}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={4}>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                    {`Valor Nominal: ${moneyFormat(contrato?.estado?.valorNominal)}`}
                                </Typography>
                            </Grid> */}
                            {/* <Grid item xs={4}>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                    {`Adelanto Inicial: ${moneyFormat(contrato?.contrato?.adelantoInicialNominal)}`}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={4}>
                                <Typography sx={{ marginTop: '.6em' }} color="text.secondary">
                                    {`Porcentaje Prima: ${(contrato?.contrato?.perPrimaAdjudicacion * 100 || 0).toFixed(2)}%`}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={4}>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                    {`Adelanto Prepactado: ${moneyFormat(adelantoRecurrenteNominal)}`}
                                </Typography>
                            </Grid> */}
                        </Grid>
                        {/* <Button onClick={() => setShowSuscripcion(true)} component="button" variant="contained" size="medium" sx={{ marginTop: '1em' }}> Mi Plan </Button> */}
                        {/* <Button onClick={() => setAdelantarPago(true)} component="button" color="primary" variant="contained" size="medium" sx={{ marginTop: '1em' }}> Adelantar </Button> */}
                    </CardContent>
                </Card>
            );
        };

        const BreadcumbHeader = (props) => {
            return <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" onClick={() => navigate(`/dashboard/miscontratos`)}>Mis Contratos</Link>
                <Link underline="hover" color="inherit" onClick={() => navigate(`/dashboard/miscontratos/${contratoId}`)}>{zfill(contratoId, 6)}</Link>
            </Breadcrumbs>
        }

        const MiPlan = (props) => {

            const [cuotasMensuales, setCuotasMensuales] = useState(1);

            return (
                <Dialog
                    open={showSuscripcion}
                    keepMounted
                    onClose={() => setShowSuscripcion(false)}
                    aria-describedby="alert-dialog-slide-description"
                    //fullWidth={true}
                    maxWidth={"md"}
                    PaperProps={{ style: { minHeight: '25%', } }}
                >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} textAlign="center">{"Mi Plan: "}</DialogTitle>
                    <DialogContent dividers>
                        <FormContainer defaultValues={{ montoNominal: '' }} onSuccess={console.log} >
                            <Box sx={{ flexWrap: 'wrap' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={8}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox defaultChecked />} label="Refuerzo Aguinaldo" />
                                            <Typography id="input-slider" gutterBottom>{`Cuotas Eq Mensuales: ${cuotasMensuales}`}</Typography>
                                            <Slider disableSwap value={cuotasMensuales} onChange={e => setCuotasMensuales(e.target.value)} step={0.1} min={0.5} max={5} aria-label="Disabled slider" />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={4}></Grid>
                                    <Grid item xs={8}>
                                        <FormControl>
                                            <TextField label="Pago Mensual: " value={moneyFormat(cuotasMensuales * 234323.33)} contentEditable={false} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}></Grid>
                                    <Grid item xs={8}>
                                        <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="contained" onClick={() => setShowSuscripcion(false)} sx={{ marginRight: '5px' }}>{"Guardar"}</Button>
                                        <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" onClick={() => setShowSuscripcion(false)}>{"Cancelar"}</Button>
                                    </Grid>
                                </Grid>


                            </Box>
                        </FormContainer>
                    </DialogContent>
                </Dialog>
            )
        }

        const AdelantarPago = () => {

            async function submitAdelantarPago(formObj) {
                let newPago = { montoNominal: parseInt(formObj.montoNominal) * 100, contratoId: parseInt(contratoId) };

                try {
                    let res = await crearLink(newPago).unwrap();
                    let pagoUrl = res[0].body.init_point;
                    setAdelantarPago(false);
                    window.open(pagoUrl, '_blank');
                    console.log("Adelanto de pago res: " + res);
                } catch (error) {
                    console.log(error);
                    console.log("Error adelantando pago");
                }
            }

            return (
                <Dialog
                    open={adelantarPago}
                    TransitionComponent={forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />)}
                    keepMounted
                    onClose={() => setAdelantarPago(false)}
                    aria-describedby="alert-dialog-slide-description"
                    //fullWidth={true}
                    maxWidth={"md"}
                    PaperProps={{
                        style: {
                            minHeight: '25%',
                        }
                    }}
                >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} textAlign="center">{"Nuevo Pago: "}</DialogTitle>
                    <DialogContent dividers>
                        <FormContainer defaultValues={{ montoNominal: '0' }} onSuccess={submitAdelantarPago} >
                            <Box sx={{ flexWrap: 'wrap' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ marginTop: '10px' }}>
                                        <FormControl>
                                            <TextFieldElement label="Monto: " name="montoNominal" type={'number'} required />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} type={'submit'} variant="contained" sx={{ marginRight: '5px' }}>{"Pagar"}</Button>
                                        <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" onClick={() => setAdelantarPago(false)}>{"Cancelar"}</Button>
                                    </Grid>
                                </Grid>


                            </Box>
                        </FormContainer>
                    </DialogContent>
                </Dialog>
            )
        };

        const HistoriaTable = (props) => {
            let rows = contrato?.historia?.filter(x => x.operacion.tipo?.startsWith('Pago')).map((x, i) => ({ ...x, id: i })) || [];
            let ultimaHistoria = _.last(contrato?.historia);
            rows = rows ? getBonificaciones(rows, ultimaHistoria?.claseContratoActual) : [];
            const RenderBonificaciones = (params) => {
                const [anchorEl, setAnchorEl] = useState(null);
                const [verBonificaciones, setVerBonificaciones] = useState(false);
                function handleClick(event) {
                    setAnchorEl(event.currentTarget);
                    setVerBonificaciones(true);
                }
                function handleClose() {
                    setAnchorEl(null);
                    setVerBonificaciones(false);
                }
                let bonificaciones = params?.row?.bonificaciones?.map(b => ({
                    tipoBonificacion: b.tipoBonificacion.replace('Pago ', '').replace('Recurrente', 'Prepactado'),
                    bonificacionNominal: moneyFormat(parseInt(b.bonificacionNominal) / 100)
                }))
                return (
                    <Fragment>
                    {params?.row?.bonificaciones.length > 0 ?
                    <>
                        <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ color: '#43C353', fontSize: "16px", fontWeight: "bold" }} style={{ fontWeight: "bold" }} fontSize={'16'} fontWeight={'bold'} aria-haspopup="true" onClick={handleClick}>
                            + {moneyFormat(parseInt(params?.row?.bonificacionTotal?.totalBonificaciones) / 100)}
                        </Button>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={verBonificaciones}
                            onClose={handleClose}
                            onMouseLeave={handleClose}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}>
                            <List>
                                {bonificaciones?.map((b, i) => (
                                    <ListItem key={'MenuItemBonificaciones' + i} onClick={handleClose}>
                                        <Typography>{b.tipoBonificacion}: {b.bonificacionNominal} </Typography>
                                    </ListItem>
                                ))}
                            </List>
                        </Menu>
                        </>
                        : 
                        <Fragment>
                        <Typography sx={{ color: '#43C353', fontSize: "16px", fontWeight: "bold", marginLeft: '0.5em' }} >
                            + {moneyFormat(parseInt(params?.row?.bonificacionTotal?.totalBonificaciones) / 100)}
                        </Typography>
                        </Fragment>
                    }
                    </Fragment>
                );
            };
            const columns = [
                { field: 'id', headerName: 'ID', flex: 10 },
                { field: 'fecha', headerName: 'Fecha', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}> Fecha</Typography>), flex: 90, valueGetter: v => getFecha(parseInt(v.row.operacion?.data?.fechaValor)), sortComparator: fechaSortComparator, renderCell: (v) => <Typography fontSize={'16'}  >{v.value}</Typography> },
                //{ headerName: 'Valor Nominal', flex: 80, renderCell: v => moneyFormat(v.value) },
                { field: 'operacion', headerName: 'Operación', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}> Operación</Typography>), flex: 90, valueGetter: v => (v.row?.operacion?.data?.descripcion === "Ajuste Sistema" ||  v.row?.operacion?.tipo === 'Pago Activado' ? v.row?.operacion?.data?.descripcion : v.row?.operacion?.tipo), renderCell: (v) => <Typography fontSize={'16'}  >{v.value}</Typography> },
                //{ field: 'subTipo', headerName: 'Medio', flex: 90, valueGetter: v => v.row?.operacion?.data?.descripcion, renderCell: v => v.value ? v.value : '-' },
                { field: 'montoNominal', headerName: 'Monto', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}> Monto</Typography>), flex: 90, valueGetter: v => v.row?.operacion.data?.montoNominal, renderCell: (v) => v.value ? <Typography fontSize={'16'}  >{moneyFormat(v.value / 100)}</Typography> : '-' },
                // { field: 'tipoBonificacion', headerName: 'Bonificación Adelantos', flex: 90, valueGetter: v => v.row?.bonificacionTotal?.tipoBonificaciones },
                // { field: 'importeBonificacion', headerName: 'Importe Bonificado', flex: 90, valueGetter: v => v.row?.bonificacionTotal?.bonificacionesNominal },
                {
                    field: 'bonificaciones',
                    headerName: 'Bonificación',
                    renderHeader: (params) => (<Typography fontWeight={'bold'} color={'#43C353'}>Bonificación</Typography>),
                    flex: 90,
                    renderCell: RenderBonificaciones,
                },
                {
                    field: 'importeReconocido', headerName: 'Importe Reconocido', headerClassName: 'super-app-theme--header', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}>Importe Reconocido</Typography>), flex: 90, valueGetter: v => v.row?.bonificacionTotal?.importeTotal,
                    renderCell: (v) => <Typography color={'#616161'} fontSize={'16'} fontWeight={700}  >{v.value ? moneyFormat(v.value / 100) : 'N/A'}</Typography>
                },
                { field: 'gradoAvance', headerName: 'GA%', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}>GA%</Typography>), flex: 50, valueGetter: v => v.row?.bonificacionTotal?.gradoAvanceTotal, renderCell: v => <Typography fontSize={'16'}  >{v.value ? (v.value * 100)?.toFixed(2) + '%': 'N/A'}</Typography> },
                { field: 'cuotasEq', headerName: 'Cuotas Eq.', renderHeader: (params) => (<Typography fontSize={'16'} fontWeight={'bold'} color={'#43C353'}> Cuotas Eq.</Typography>), flex: 60, valueGetter: v => v.row?.bonificacionTotal?.cuotasTotal, renderCell: v => <Typography fontSize={'16'}  >{v.value ? (v.value)?.toFixed(2): 'N/A'}</Typography> },

                // { field: 'detalles', headerName: 'Detalles', flex: 90, valueGetter: v => v.row.operacion.tipo, renderCell: v => v.value === 'Pago' ? <Button onClick={e => setDetallePago(rows[v.id])}>Ver</Button> : '-' },
            ]

            return <Box sx={{ height: 600, minWidth: 275, margin: '10px' }}>
                <DataGrid
                    autoHeight
                    style={{ minHeight: '600px' }}
                    getRowId={r => r.id}
                    rows={rows}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[5]}
                    //checkboxSelection
                    //disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    // onSelectionModelChange={setSelectedUsersId}
                    //components={{ Toolbar: GridToolbar }}
                    componentsProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                        sorting: {
                            sortModel: [{ field: 'id', sort: 'desc' }],
                        },
                    }}
                />
            </Box>
        }

        const DetallePago = (props) => {
            const rows = (detallePago?.operacion?.subHistoria || []).map((x, i) => ({ ...x, id: i }));
            const columns = [
                { field: 'tipo', valueGetter: v => v.row.operacion.tipo, headerName: 'Tipo', flex: 200 },
                { field: 'valorCAC', valueGetter: v => (v.row.operacion.data.valorCAC).toFixed(2), headerName: 'Valor CAC', flex: 100 },
                { field: 'valorNominal', valueGetter: v => moneyFormat(v.row.operacion.data.valorNominal / 100), headerName: 'Valor Nominal', flex: 100, sortComparator: importeSortComparator },
                { field: 'perBonificacion', valueGetter: v => (v.row.operacion.data.perBonificacion * 100).toFixed(2) + '%', headerName: '% Bonificacion', flex: 100 },
                { field: 'perGradoAvance', valueGetter: v => (v.row.operacion.data.perGradoAvance * 100).toFixed(2) + '%', headerName: '% Grado de Avance', flex: 100 },
                { field: 'cuotasEquivalentes', valueGetter: v => (v.row.operacion.data.cuotasEquivalentes).toFixed(2), headerName: 'Cuotas Eq.', flex: 100 },
                { field: 'm2Equivalentes', valueGetter: v => (v.row.operacion.data.m2Equivalentes).toFixed(2), headerName: 'm2 Eq.', flex: 100 },
                //{ headerName: 'Valor Nominal', flex: 80, renderCell: v => moneyFormat(v.value) },
            ]
            return (
                <Dialog
                    open={detallePago}
                    keepMounted
                    onClose={() => setShowSuscripcion(false)}
                    aria-describedby="alert-dialog-slide-description"
                    fullWidth={true}
                    maxWidth={"xl"}
                    PaperProps={{ style: { minHeight: '25%', } }}
                >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} textAlign="center">{"Detalle Pago: "}</DialogTitle>
                    <DialogContent dividers>
                        <Box sx={{ height: 400, minWidth: 275, margin: '10px', marginBottom: '40px' }}>
                            <DataGrid
                                getRowId={r => r.id}
                                rows={rows}
                                columns={columns}
                                pageSize={100}
                                rowsPerPageOptions={[5]}
                                //checkboxSelection
                                //disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                hideFooterPagination
                                hideFooterSelectedRowCount
                            // onSelectionModelChange={setSelectedUsersId}
                            //components={{ Toolbar: GridToolbar }}
                            // componentsProps={{
                            //     toolbar: {
                            //         showQuickFilter: true,
                            //         quickFilterProps: { debounceMs: 500 },
                            //     },
                            // }}
                            />
                            <Button component={motion.div} whileHover={{ scale: 1.2, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" onClick={() => setDetallePago(null)}>{"Aceptar"}</Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )
        }

        return (
            <Fragment>
                <BreadcumbHeader />
                <ContratoInformacionResumida {...contrato} />
                <HistoriaTable />
                <AdelantarPago />
                <MiPlan />
                <DetallePago />
            </Fragment>
        )
    };



    return (<>{contratoId ? <Contrato /> : <MisContratos />}</>)
}

export default MisContratosCat